import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { fetchAchievements } from "../api/enterpriseClient";

export const achievementsQueryOptions = (customerId: number) =>
  queryOptions({
    queryKey: ["enterprise-achievements", customerId],
    queryFn: () => fetchAchievements(customerId),
    staleTime: 5 * 60_000,
  });

export function useGetAchievements(customerId: number) {
  return useSuspenseQuery(achievementsQueryOptions(customerId));
}
